import React from "react";
import { Text } from "@twilio-paste/text";
import { useSelector } from "react-redux";
import type { AppState } from "../store";
import styles from "../styles";

export const SignalRStatusBadge: React.FC = () => {
  const { connected, connecting, error } = useSelector(
    (s: AppState) => s.signalr
  );

  let text = "offline";
  let textColor: React.ComponentProps<typeof Text>["color"] = "colorTextWeaker";

  if (connecting) {
    text = "Connessione in corso…";
    textColor = "colorTextIconBusy";
  } else if (connected) {
    text = "Online";
    textColor = "colorTextPrimaryWeak";
  }

  if (error) {
    text = "Errore di connessione";
    textColor = "colorTextError";
  }

  return (
    <Text as="span" color={textColor} style={styles.userStatus}>
      {text}
    </Text>
  );
};
